import { render, staticRenderFns } from "./HintSound.vue?vue&type=template&id=45adb295&scoped=true"
import script from "./HintSound.vue?vue&type=script&lang=js"
export * from "./HintSound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45adb295",
  null
  
)

export default component.exports